module.exports = __webpack_public_path__ + "img/hr-concrete-side-mask.a23effe6.png";